import React, { useEffect, useState } from 'react';
import api from '../../../config/axios';

import FormularioModal from './modals/Formulario';

import { FaPlus, FaEdit, FaFilter } from 'react-icons/fa';
import Paginacao from '../../../components/utils/paginacao';

const Formularios = () => {
  const [error, setError] = useState(null);

  const [formularios, setFormularios] = useState([]);
  const [filtroNome, setFiltroNome] = useState('');

  const [selectedFormulario, setSelectedFormulario] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;

  const fetchFormularios = async (currentPage) => {
    try {
      const response = await api.get(`/anamnese-formularios?page=${currentPage}&limit=${limit}&ds_formulario=${filtroNome}`);

      setFormularios(response.data.records || []);
      setTotalPages((Math.ceil(response.data.totalRegistros / limit)) || 1);
      setError(null);
    } catch (err) {
      setError('Erro ao carregar a lista de formulários.');
    }
  };

  useEffect(() => {
    fetchFormularios(currentPage);
  }, [currentPage]);

  const handlePageChange = (currentPage) => {
    setCurrentPage(currentPage);
  };
  
  const handleAddFormulario = () => {
    setSelectedFormulario(null);
    setIsModalOpen(true);
  };

  const handleEditFormulario = (pergunta) => {
    setSelectedFormulario(pergunta);
    setIsModalOpen(true);
  };

  const handleFiltrar = () => {
    fetchFormularios(1);
  };

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12">
              <h4 className="fw-bold">Formulários</h4>
            </div>
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-md-8 col-12">
              <button className="btn btn-outline-primary" onClick={handleAddFormulario}>
                <FaPlus /> Adicionar Formulário
              </button>
            </div>
            <div className="col-md-4 col-12 mt-3 mt-md-0">
              <div className="input-group mb-3">
                <input
                  type="text"
                  placeholder="Digite o nome do formulário"
                  autoComplete="off"
                  value={filtroNome}
                  className="form-control"
                  onChange={(e) => setFiltroNome(e.target.value.toUpperCase())}
                />
                <button
                  type="button"
                  className="btn btn-outline-dark"
                  onClick={handleFiltrar}
                >
                  <FaFilter /> Filtrar
                </button>
              </div>
            </div>
          </div>


          {error ? (
            <p className="error-message">{error}</p>
          ) : (
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead className="table-custom-primary">
                    <tr>
                      <th>Nome</th>
                      <th className="text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formularios.map((formulario) => (
                      <tr key={formulario.id}>
                        <td className="text-nowrap">{formulario.ds_formulario}</td>
                        <td className="text-center">
                          <button
                            className="btn btn-custom-secondary btn-sm"
                            onClick={() => handleEditFormulario(formulario)}
                          >
                            <FaEdit />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

          <div className="d-flex justify-content-end mt-4">
            <Paginacao
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
        
        {isModalOpen && (
          <FormularioModal
            formulario={selectedFormulario}
            onClose={() => setIsModalOpen(false)}
            onFormularioAtualizado={() => fetchFormularios(currentPage)}
          />
        )}
      </div>
      <div style={{ height: '50px' }}></div>
    </div>
  );
};

export default Formularios;
